import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { Row, Col } from "react-bootstrap";
import { api } from "../App";
import {
  fetchEstimatedTimeCustomersSpend,
  createEstimatedTimeCustomersSpend,
  patchEstimatedTimeCustomersSpend,
  fetchHoursEach,
} from "../actions/restaurantActions";
import Loader from "./Loader";
import { Modal, Button } from "react-bootstrap";
import SelectableTimeInputForEstimatedTime from "./SelectableTimeInputForEstimatedTime";
import DropDownButton from "../components/DropDownButton";
import ScrollInputOptions from "../components/ScrollInputOptions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faChair,
  faGear,
  faCircleXmark,
  faClock,
  faUser,
  faPen,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import {
  ContainerBox,
  Header,
  Body,
  OrangeButton,
  Title,
} from "../components/DefaultImports";
import { XSvgIcon } from "../icons/SvgIcons";
import { CustomModal } from "./CustomModal";
import { ModernButton } from "../components/DefaultImports";
import { ConfirmationModal } from "./ConfirmationModal";
import DropDownButtonTime from "./DropDownButtonTime";

const EstimatedTimePage = ({ restaurant_ids }) => {
  const dispatch = useDispatch();
  const params = useParams();
  const [options, setOptions] = useState(
    Array.from({ length: 100 }, (_, i) => i + 1)
  );
  const [editingItem, setEditingItem] = useState(false);
  const [peopleNumer, setPeopleNumer] = useState(0);
  const [selectedTime, setSelectedTime] = useState("00:30");
  const [itemId, setItemId] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);

  const [restaurant_id, setRestaurant_id] = useState(restaurant_ids);

  const estimatedTimes = useSelector(
    (state) => state.estimatedTimeCustomersSpend
  );
  const { estimatedTime } = estimatedTimes;

  //  state to store the input values
  const [inputValues, setInputValues] = useState({});
  const setTimeListWithHours = () => {
    let time = new Date(0, 0, 0, 0, 0, 0, 0); // Start at midnight
    let end = new Date(0, 0, 0, 10, 0, 0, 0); // End at 10:00
    let timeList = [];

    while (time <= end) {
      let hour = time.getHours().toString().padStart(2, "0");
      let minutes = time.getMinutes().toString().padStart(2, "0");

      timeList.push(`${hour}:${minutes}`);
      time.setMinutes(time.getMinutes() + 15);
    }

    return timeList;
  };
  const [timeList, setTimeList] = useState(setTimeListWithHours());

  const hoursEachTime = useSelector((state) => state.hoursEachTime);
  const { hoursEach } = hoursEachTime;

  useEffect(() => {
    dispatch(fetchEstimatedTimeCustomersSpend(restaurant_id));
    dispatch(fetchHoursEach(restaurant_id));
  }, []);

  const handleDelete = async (id) => {
    try {
      const response = await api.delete(
        `/restaurants/${restaurant_id}/estimatedtime/${id}/`
      );
      // Handle the response here (e.g., update your component's state)
    } catch (error) {
      // Handle the error here (e.g., display an error message)
      console.error(error);
    }
    dispatch(fetchEstimatedTimeCustomersSpend(restaurant_id));
  };

  const triggerDelete = (id) => {
    setDeleteItemId(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      await api.delete(
        `/restaurants/${restaurant_id}/estimatedtime/${deleteItemId}/`
      );
      dispatch(fetchEstimatedTimeCustomersSpend(restaurant_id));
    } catch (error) {
      console.error(error);
    }
    setShowDeleteModal(false);
    setDeleteItemId(null);
  };

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const handleCreate = () => {
    // dispatch action to create new item
    const params = {
      restaurant: restaurant_id,
      number_of_people: peopleNumer,
      estimated_time: selectedTime,
    };
    dispatch(createEstimatedTimeCustomersSpend(restaurant_id, params));
    // close the modal
    setModalIsOpen(false);
    // clear form
    setPeopleNumer(0);
    setSelectedTime("00:00");
  };

  const handleOpenEditModal = (people, time, id) => {
    setItemId(id);
    setPeopleNumer(people);
    setSelectedTime(time);
    setEditingItem(true);
  };
  const handleEditSave = () => {
    const params = {
      number_of_people: peopleNumer,
      estimated_time: selectedTime,
    };
    dispatch(patchEstimatedTimeCustomersSpend(restaurant_id, itemId, params));

    setEditingItem(false); // Close the edit modal
  };
  const handlePeopleChange = (value) => {
    setPeopleNumer(value);
  };
  const handleSelectedTime = (value) => {
    setSelectedTime(value);
  };

  return (
    <ContainerBox>
      <Header>
        <Title>Duração média das refeições</Title>
        <OrangeButton onClick={() => setModalIsOpen(true)}>
          Adicionar
          <LargeIconPlus size="xl" icon={faPlus} />
        </OrangeButton>
      </Header>
      <Row style={{ padding: "10px" }}>
        <Col xs={4}>
          <h6>Tamanho do grupo</h6>
        </Col>
        <Col xs={5}>
          <h6>Duração média</h6>
        </Col>
      </Row>
      <Body>
        {Array.isArray(estimatedTime) ? (
          <>
            {[...estimatedTime]
              .sort((a, b) => a.number_of_people - b.number_of_people)
              .map((item) => (
                <B2 key={item.id}>
                  <Row className="g-0" style={{ width: "100%" }}>
                    <StyledCol xs={4} className="d-flex">
                      <FontAwesomeIcon
                        size="xl"
                        icon={faUser}
                        style={{ marginRight: "10px", color: "#99B0AD" }}
                      />
                      <h6 style={{ margin: "0" }}>{item.number_of_people}</h6>
                    </StyledCol>
                    <StyledCol xs={6} className="d-flex">
                      <FontAwesomeIcon
                        size="xl"
                        icon={faClock}
                        style={{ marginRight: "10px", color: "#99B0AD" }}
                      />
                      <h6 style={{ margin: "0" }}>
                        {item.estimated_time.slice(0, 5)}
                      </h6>
                    </StyledCol>
                    <StyledCol xs={2} className="d-flex justify-content-end">
                      <FontAwesomeIcon
                        onClick={() =>
                          handleOpenEditModal(
                            item.number_of_people,
                            item.estimated_time.slice(0, 5),
                            item.id
                          )
                        }
                        size="xl"
                        icon={faPen}
                        style={{ cursor: "pointer", color: "#99B0AD" }}
                      />
                      <FontAwesomeIcon
                        onClick={() => triggerDelete(item.id)}
                        icon={faXmark}
                        style={{
                          cursor: "pointer",
                          color: "#99B0AD",
                          fontSize: "35px",
                          marginLeft: "15px",
                        }}
                      />
                    </StyledCol>
                  </Row>
                </B2>
              ))}
          </>
        ) : (
          <Loader />
        )}
      </Body>

      <CustomModal
        show={modalIsOpen}
        onHide={() => setModalIsOpen(false)}
        title="Adicionar duração média"
        centered={false}
        footer={
          <>
            <ModernButton color="#EE754C" onClick={handleCreate}>
              Adicionar
            </ModernButton>
          </>
        }
      >
        <Row className="g-4 mb-3">
          <Col xs={12} md={6}>
            <StyledH5>
              <FontAwesomeIcon icon={faUser} style={{ marginRight: "8px" }} />
              Pessoas
            </StyledH5>
            <div style={{ width: "100%" }}>
              <DropDownButton
                options={options}
                handleOptionChange={handlePeopleChange}
                initialOption={peopleNumer}
              />
            </div>
          </Col>

          <Col xs={12} md={6}>
            <StyledH5>
              <FontAwesomeIcon icon={faClock} style={{ marginRight: "8px" }} />
              Tempo
            </StyledH5>
            <div style={{ width: "100%" }}>
              <DropDownButtonTime
                options={timeList}
                handleOptionChange={handleSelectedTime}
                initialOption={selectedTime}
              />
            </div>
          </Col>
        </Row>
      </CustomModal>

      {/* Modal for Editing an Item */}
      <CustomModal
        show={editingItem === true}
        onHide={() => setEditingItem(false)}
        title="Editar duração média"
        centered={false}
        footer={
          <>
            <ModernButton color="#99B0AD" onClick={() => setEditingItem(false)}>
              Cancelar
            </ModernButton>
            <ModernButton color="#ee754c" onClick={handleEditSave}>
              Gravar
            </ModernButton>
          </>
        }
      >
        <Row className="g-4 mb-3">
          <Col xs={12} md={6}>
            <StyledH5>
              <FontAwesomeIcon icon={faUser} style={{ marginRight: "8px" }} />
              Pessoas
            </StyledH5>
            <DropDownButton
              options={options}
              handleOptionChange={handlePeopleChange}
              initialOption={peopleNumer}
            />
          </Col>
          <Col xs={12} md={6}>
            <StyledH5>
              <FontAwesomeIcon icon={faClock} style={{ marginRight: "8px" }} />
              Tempo
            </StyledH5>
            <DropDownButtonTime
              options={timeList}
              handleOptionChange={handleSelectedTime}
              initialOption={selectedTime}
            />
          </Col>
        </Row>
      </CustomModal>
      <ConfirmationModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onConfirm={confirmDelete}
        onCancel={() => setShowDeleteModal(false)}
        title="Eliminar duração média"
        body="Tens a certeza que pretendes eliminar esta duração média?"
        confirmLabel="Eliminar"
        cancelLabel="Cancelar"
        confirmColor="#ee754c"
        cancelColor="#99B0AD"
        centered={false}
        topSpacing={"100px auto"}
      />
    </ContainerBox>
  );
};

export default EstimatedTimePage;

const B2 = styled.div`
  background-color: #f8f9fa;
  position: relative;
  margin-bottom: 10px;
  padding: 10px;
  border-radius: 5px;
  width: 100%;
`;

const DangerButton = styled(Button)`
  background-color: #ff704d;
  border-color: #ff704d;

  &:hover {
    background-color: #ff471a;
    border-color: #ff471a;
  }
`;

const LargeIconPlus = styled(FontAwesomeIcon)`
  margin-left: 7px; /* adjust this value as needed */
`;

const StyledCol = styled(Col)`
  margin: 0;
  padding: 0;
  align-items: center;
  display: flex;
`;

const StyledH5 = styled.h5`
  font-size: 16px;
  font-weight: 600;
  color: #99b0ad;
  width: 100%;
  text-align: left;
  margin-bottom: 12px;
  margin-top: 0;
`;
